import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import fileTex from '../images/fileTex.svg';
import RubriqDocumentCardStatus from './RubriqDocumentCardStatus';
import RubriqDocumentCardActions from './RubriqDocumentCardActions';
var RubriqDocumentCard = function RubriqDocumentCard(_ref) {
  var _document$file;
  var document = _ref.document,
    status = _ref.status,
    pagination = _ref.pagination,
    _ref$isTranslation = _ref.isTranslation,
    isTranslation = _ref$isTranslation === void 0 ? false : _ref$isTranslation,
    onDownload = _ref.onDownload;
  var extensionMap = {
    doc: 'word',
    docx: 'word',
    tex: 'tex'
  };
  var extension = (_document$file = document.file) === null || _document$file === void 0 || (_document$file = _document$file.name) === null || _document$file === void 0 ? void 0 : _document$file.split('.').pop().toLowerCase();
  var fileType = extensionMap[extension] || 'word';
  if (document.origin === 'wai') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center border p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 d-flex flex-column gap-1 me-3",
    style: {
      minWidth: '0',
      maxWidth: '50%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2",
    style: {
      minWidth: '0'
    }
  }, fileType === 'tex' ? /*#__PURE__*/React.createElement("img", {
    src: fileTex,
    alt: "",
    width: "15px",
    height: "15px"
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: ['fal', 'file-word']
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5 text-truncate"
  }, document.file.name)), /*#__PURE__*/React.createElement("div", {
    className: "ms-2",
    style: {
      paddingLeft: '11.25px'
    }
  }, /*#__PURE__*/React.createElement(RubriqDocumentCardStatus, {
    document: document,
    isTranslation: isTranslation
  }))), /*#__PURE__*/React.createElement(RubriqDocumentCardActions, {
    document: document,
    status: status,
    pagination: pagination,
    isTranslation: isTranslation,
    onDownload: onDownload,
    fileType: fileType
  }));
};
export default RubriqDocumentCard;